module.exports = __webpack_public_path__ + "img/step4b-en.fd74a8f1.webp";